import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
export var pickComponentCommonProps = function pickComponentCommonProps(props) {
  return pick(props, ['className', 'data-testid', 'id']);
};
export var pickAriaProps = function pickAriaProps(props) {
  return pickBy(props, function (_, key) {
    return key.startsWith('aria-');
  });
};
export var pickDataProps = function pickDataProps(props) {
  return pickBy(props, function (_, key) {
    return key.startsWith('data-');
  });
};